import React from 'react';
import '../template-file-css/document-file-template.css';


export const RPBS_CcbhProviderChoiceLetter = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RPBS_CcbhProviderChoiceLetter' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'> <h3>Client Community Behavioral Health Provider Choice Letter
                </h3></p>
                <p className='w-750'>{`Dear Client, Parent, or Guardian:`}</p>
                <p className='w-750'>
                    {`You have the right and freedom to choose a community behavioral helath provider for yourself or child/ward. As such, we are required to advise you that the community behavioral helath providers in your immediate
            area include Right Path Behavioral Health Service (RPBHS) and the following (please note that this list is not exhaustive):`}
                </p>
                <p className='w-750'><ul>
                    <li>Daniel Memorial (Duval County)
                    </li>
                    <li>Mental Health Resource Center (Duval County)
                    </li>
                    <li>Northwest Behavioral Health (Duval County)
                    </li>
                    <li>Child Guidance Center (Duval County)
                    </li>
                    <li>Children's Home Society (Duval County)
                    </li>
                    <li>Clay Behavioral Health Services (Clay County)
                    </li>
                </ul></p>
                <p className='w-750'>
                    {`By singing below, you acknowledge that a RPBHS staff person has advised you of your right and freedom to choose a behavioral provider for you, you child, or your ward and has provided you with names of the community behavioral health providers available in your area.`}
                </p>
                <table>
                    <tr>
                        <td className='signature w-750'>&nbsp;</td>

                    </tr>
                    <tr>
                        <td className='small w-750'>Signature</td>

                    </tr>
                </table>


            </div>
        </form>

    )
}











